export const Colors = {
    Primary: '#4739ea',
    Secondary: '#00ffa3'
    , Black: '#000'
    , White: '#FFF'
    , Gray: '#999'
    ,LightGray: '#cdcdcd'
    ,GoodGreen: '#8ce981'
    ,ErroRed:'#FA685E'
}